require('normalize.css/normalize.css');
require('../styles/index.scss');
import MobileDetect from 'mobile-detect';
import { TimelineMax, TweenMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/minified/plugins/animation.gsap.min';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min';
import $ from 'jquery';

/*
Polyfills
 */
// NodeList.prototype.forEach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
// Array.prototype.forEach
if (!Array.prototype.forEach) {

    Array.prototype.forEach = function (callback /*, thisArg*/) {

        var T, k;

        if (this == null) {
            throw new TypeError(' this vaut null ou n est pas défini');
        }

        var O = Object(this);


        var len = O.length >>> 0;


        if (typeof callback !== "function") {
            throw new TypeError(callback + ' n est pas une fonction');
        }


        if (arguments.length > 1) {
            T = arguments[1];
        }

        k = 0;

        while (k < len) {

            var kValue;


            if (k in O) {


                kValue = O[k];


                callback.call(T, kValue, k, O);
            }
            k++;
        }
    };
}
/*
End Polyfills
 */

var md = new MobileDetect(window.navigator.userAgent);

function init () {

    $(document).ready(function () {

        /* DOM changes */
        if ($(window).width() > 767) {
            $('.deja-demain__prod--content-text img').appendTo('.deja-demain__prod--content-text .right');
            $('.deja-demain__usine--kit-img + .deja-demain__usine--kit-img').appendTo('.deja-demain__usine--kit-text');
            $('.deja-demain__futur--maillon-text').appendTo('.deja-demain__futur--maillon .right');
        }

        /* Mobile Menu */
        var $mobileNav = $('.deja-demain__navbar .navbar-collapse').hide();
        $('.deja-demain__navbar .navbar-toggler').click(function () {
            $mobileNav.slideToggle();
            return false;
        });

        /* Mobile Toggle Content */
        if ($(window).width() < 768) {
            var $contentToggle = $('.deja-demain .content-toggle').hide();
            $('.deja-demain .btn-toggler').click(function () {
                $(this).toggleClass('open').next($contentToggle).slideToggle();
                return false;
            });
        }

        // CLOSE MENU ONCLICK
        document.querySelectorAll('.menu .navbar-collapse li a').forEach(function (item) {
            item.addEventListener('click', function (e) {
                document.querySelector('.menu .navbar-collapse').style.display = 'none';
            })
        });

        if (md.mobile()) {
            //alert('md.mobile');
            $('.deja-demain__start--title .title.prod').prependTo($('#prod')).wrap('<div class="deja-demain__start--title section-header"></div>');
            $('.deja-demain__start--title .title.usine').prependTo($('#usine')).wrap('<div class="deja-demain__start--title section-header"></div>');
            $('.deja-demain__start--title .title.futur').prependTo($('#futur')).wrap('<div class="deja-demain__start--title section-header"></div>');
            return;
        }

        var smController = new ScrollMagic.Controller({
            addIndicators: false
        });

        // SECTION TITLES
        document.querySelector('.deja-demain__start--title').style.display = 'block';
        document.querySelectorAll('.deja-demain__start--title .title').forEach(function (item) {
            item.style.display = 'none';
        });

        new ScrollMagic.Scene({
            triggerElement: '#prod',
            triggerHook: .45,
            duration: function () {
                return document.querySelector('#prod').offsetHeight;
            }
        })
        //.addIndicators({name: 'triggerProd',indent: 100})
            .on('enter', () => {
                document.querySelector('.deja-demain__start--title .title.prod').style.display = 'block';
                document.querySelector('.navbar-collapse').setAttribute('data-active', 'prod');
            })
            .on('leave', (event) => {
                document.querySelector('.deja-demain__start--title .title.prod').style.display = 'none';
                if (event.scrollDirection === 'REVERSE') {
                    document.querySelector('.navbar-collapse').setAttribute('data-active', 'start');
                }
            })
            .addTo(smController);

        new ScrollMagic.Scene({
            triggerElement: '#usine',
            duration: function () {
                return document.querySelector('#usine').offsetHeight;
            }
        })
        //.addIndicators({name: 'triggerUsine'})
            .on('enter', () => {
                console.log('enter usine');
                document.querySelector('.deja-demain__start--title .title.usine').style.display = 'block';
                document.querySelector('.navbar-collapse').setAttribute('data-active', 'usine');
            })
            .on('leave', () => {
                console.log('leave usine');
                document.querySelector('.deja-demain__start--title .title.usine').style.display = 'none';
            })
            .addTo(smController);

        new ScrollMagic.Scene({
            triggerElement: '#futur',
            duration: function () {
                return document.querySelector('#futur').offsetHeight + 300;
            }
        })
        //.addIndicators({name: 'triggerFutur'})
            .on('enter', (event) => {
                document.querySelector('.deja-demain__start--title .title.futur').style.display = 'block';
                document.querySelector('.navbar-collapse').setAttribute('data-active', 'futur');
            })
            .on('leave', (event) => {
                if (event.scrollDirection === 'FORWARD') {
                    document.querySelector('.navbar-collapse').setAttribute('data-active', 'playlist');
                }
                document.querySelector('.deja-demain__start--title .title.futur').style.display = 'none';
            })
            .addTo(smController);

        // STARS #START
        new ScrollMagic.Scene({
            triggerElement: '#start',
            triggerHook: 0,
            duration: function () {
                return window.innerHeight;
            }
        })
        //.addIndicators({name: 'starsStart',indent: 200})
            .on('progress', function (e) {
                document.querySelector('#start .stars1').style.top = -(e.progress) * 10 + '%';
                document.querySelector('#start .stars2').style.top = -(e.progress) * 15 + '%';
                document.querySelector('#start .stars3').style.top = -(e.progress) * 5 + '%';
            })
            .addTo(smController);
        // STARS #PLAYLIST
        new ScrollMagic.Scene({
            triggerElement: '#playlist',
            duration: function () {
                return window.innerHeight * 1.5;
            }
        })
        //.addIndicators({name: 'starsPlaylist',indent: 200})
            .on('progress', function (e) {
                document.querySelector('#playlist .stars1').style.top = -(e.progress) * 10 + '%';
                document.querySelector('#playlist .stars2').style.top = -(e.progress) * 15 + '%';
                document.querySelector('#playlist .stars3').style.top = -(e.progress) * 5 + '%';
            })
            .addTo(smController);

        // START : CAR
        var startCarTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__start--content-car-img', 1, {
                x: '-150%'
            }), 0)
            .add(TweenMax.from('.deja-demain__start--content-car-img', 1.5, {
                ease: Power1.easeOut,
                y: '+=5',
                yoyo: true,
                repeat: -1
            }), 1);
        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__start--content-car'
        })
        //.addIndicators({name: 'startCar'})
            .setTween(startCarTw)
            .on('start', () => {
                startCarTw.play();
            })
            .addTo(smController);

        // PROD : CHOC
        var prodChocTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__prod--content-title-1', .5, {
                y: '+=50%',
                opacity: 0
            }), 0)
            .add(TweenMax.from('.deja-demain__prod--content-title-2', .5, {
                y: '+=50%',
                opacity: 0
            }), .5);
        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__prod--content-title',
            triggerHook: .35
        })
        //.addIndicators({name: 'prodChoc'})
            .setTween(prodChocTw)
            .on('start', () => {
                prodChocTw.play();
            })
            .addTo(smController);

        // PROD : QUOTE
        var prodQuoteTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__prod--usine-text blockquote', 1, {
                text: ''
            }), 0)

        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__prod--usine-text',
            triggerHook: .65
        })
        //.addIndicators({name: 'prodQuote'})
            .setTween(prodQuoteTw)
            .on('start', () => {
                prodQuoteTw.play();
            })
            .addTo(smController);

        // PROD : VIDEO
        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__prod--video',
            triggerHook: .65
        })
        //.addIndicators({name: 'prodVideo'})
            .on('start', () => {
                document.querySelector('.deja-demain__prod--video video').play();
            })
            .addTo(smController);

        // DIGITAL : QUOTE
        var digitalQuoteTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__futur--digital blockquote', 1, {
                text: ''
            }), 0)

        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__futur--digital',
            triggerHook: .45
        })
        //.addIndicators({name: 'digitalQuote'})
            .setTween(digitalQuoteTw)
            .on('start', () => {
                digitalQuoteTw.play();
            })
            .addTo(smController);

        // DIGITAL : COBOT
        var digitalCobotTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__futur--digital-img-1', 1, {
                x: '+150%'
            }), 0);
        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__futur--digital',
            triggerHook: .5
        })
        //.addIndicators({name: 'digitalCobot'})
            .setTween(digitalCobotTw)
            .on('start', () => {
                digitalCobotTw.play();
            })
            .addTo(smController);

        // USINE : VIGNETTES
        var usineVignettesTw = new TimelineMax({
            paused: true
        });
        document.querySelectorAll('.deja-demain__usine--kit .deja-demain__usine--kit-vignettes .page-row img').forEach((item) => {
            usineVignettesTw.add(TweenMax.from(item, .5, {
                opacity: 0,
                ease: Power1.easeOut,
                transformOrigin: 'center center'
            }), "-=" + .35);
        });

        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__usine--kit-vignettes',
            triggerHook: .75
        })
        //.addIndicators({name: 'usineVignettes'})
            .setTween(usineVignettesTw)
            .on('start', () => {
                usineVignettesTw.play();
            })
            .addTo(smController);

        // DIGITAL : POPS
        var digitalPopsTw = new TimelineMax({
            paused: true
        })
            .add(TweenMax.from('.deja-demain__futur--maillon-img-img-2', .5, {
                scale: 0,
                ease: Elastic.easeOut,
                transformOrigin: 'center center'
            }), 0)
            .add(TweenMax.from('.deja-demain__futur--maillon-img-img-3', .5, {
                scale: 0,
                ease: Elastic.easeOut
            }), .25)
            .add(TweenMax.from('.deja-demain__futur--maillon-img-img-4', .5, {
                scale: 0,
                ease: Elastic.easeOut
            }), .45);
        new ScrollMagic.Scene({
            triggerElement: '.deja-demain__futur--maillon'
        })
        //.addIndicators({name: 'digitalPops'})
            .setTween(digitalPopsTw)
            .on('start', () => {
                digitalPopsTw.play();
            })
            .addTo(smController);
    });
}

// Conditional loading of LazyLoad : v10 with IntersectionObserver API for modern browsers, v8 for oldies.
(function (w, d) {
    init();
}(window, document));

window.onbeforeunload = function () {
    document.body.style.display = 'none';
    window.scrollTo(0, 0);
};
